import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { TextField } from "@mui/material";
import { convertToHTML } from "draft-convert";
import { EditorState } from "draft-js";
import React, { useState } from "react";
import { Accordion, Button } from "react-bootstrap";
import "./CreateEventRound.css";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import DateTimePicker from "@mui/lab/DateTimePicker";
import moment from "moment";
import axios from "axios";
import swal from "sweetalert";

const CreateEventRound = ({
  audition_id,
  audition_round_id,
  setAuditionJudgeInstructions,
  setIsAllStarResponsed,
  setIsAnyStarResponsed,
  setIsAlreadySubmitted,
}) => {
  const [count, setCount] = useState(1); // useState returns a pair. 'count' is the current state. 'setCount' is a function we can use to update the state.

  const [title, setTitle] = useState("");
  const [timeBoundery, setTimeBoundery] = useState(new Date());
  const [imagedata, setImagedata] = useState("");
  const [videodata, setVideodata] = useState("");
  const [file, setFile] = useState("");
  const [errorList, setErrorList] = useState([]);

  const handleImageChange = (file) => {
    setFile(URL.createObjectURL(file[0]));
    setImagedata(file[0]);
  };

  const handleVideoChange = (file) => {
    setVideodata(file[0]);
  };

  function increment() {
    //setCount(prevCount => prevCount+=1);
    setCount(function (prevCount) {
      return (prevCount += 1);
    });
  }

  function decrement() {
    setCount(function (prevCount) {
      if (prevCount > 0) {
        return (prevCount -= 1);
      } else {
        return (prevCount = 0);
      }
    });
  }

  const [convertedContent, setConvertedContent] = useState(null);

  const [editorState, setEditorState] = useState(() =>
    EditorState.createEmpty()
  );

  const handleEditorChange = (state) => {
    setEditorState(state);
    convertContentToHTML();
  };

  const convertContentToHTML = () => {
    let currentContentAsHTML = convertToHTML(editorState.getCurrentContent());
    setConvertedContent(currentContentAsHTML);
  };

  const submitEventRound = async (e) => {
    e.preventDefault();

    const formData = new FormData();

    formData.append("title", title);
    formData.append("description", convertedContent);
    formData.append(
      "time_boundary",
      moment(timeBoundery).format("yyyy-MM-DD HH:mm:ss")
    );
    formData.append("banner", imagedata);
    formData.append("video", videodata);
    formData.append("number_of_videos", count);
    formData.append("audition_id", audition_id);
    formData.append("audition_round_id", audition_round_id);

    axios.post(`/api/audition-admin/audition/sendDummyInstructionToJudges`, formData).then((res) => {
      if (res.data.status === 200) {
        swal("Welcome", res.data.message, "success");
        setAuditionJudgeInstructions(res.data.audition_judge_instructions);
        setIsAllStarResponsed(res.data.is_all_star_responsed);
        setIsAnyStarResponsed(res.data.is_any_star_responsed);
        setIsAlreadySubmitted(res.data.is_already_submitted);
      } else if (res.data.status === 422) {
        setErrorList(res.data.validation_errors);
      }
    });
  };

  return (
    <>
      <div className="createEventContainer">
        <Accordion defaultActiveKey="0">
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              Send dummy insctruction to Judges
            </Accordion.Header>
            <Accordion.Body>
              <div className="my-2">
                <form encType="multipart/formdata" onSubmit={submitEventRound}>
                  <div className="row ms-5">
                    <div className="form-group row mt-3">
                      <label
                        for="staticEmail"
                        className="col-sm-2 col-form-label text-light "
                      >
                        Instruction Title
                      </label>
                      <div className="col-sm-8">
                        <input
                          type="text"
                          className="form-control Frombtns"
                          placeholder="Enter instruction title"
                          value={title}
                          onChange={(e) => setTitle(e.target.value)}
                        />
                        <span className="text-danger">{errorList.title}</span>
                      </div>
                    </div>

                    <div className="form-group row mt-3">
                      <label
                        for="inputPassword"
                        className="col-sm-2 col-form-label text-light "
                      >
                        Instruction Details
                      </label>
                      <div className="col-sm-8">
                        <CKEditor
                          editor={ClassicEditor}
                          data={convertedContent}
                          onReady={(editor) => {
                            // You can store the "editor" and use when it is needed.
                          }}
                          onChange={(event, editor) => {
                            const data = editor.getData();
                            setConvertedContent(data);
                          }}
                          onBlur={(event, editor) => {
                          }}
                          onFocus={(event, editor) => {
                          }}
                        />
                        <span className="text-danger">
                          {errorList.description}
                        </span>
                      </div>
                    </div>
                    <div className="form-group row mt-3">
                      <label
                        for="inputPassword"
                        className="col-sm-2 col-form-label text-light "
                      >
                        Time boundary
                      </label>
                      <div className="col-sm-8">
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <DateTimePicker
                            renderInput={(props) => <TextField {...props} />}
                            value={timeBoundery}
                            onChange={(getStartTime) => {
                              setTimeBoundery(getStartTime);
                            }}
                          />
                        </LocalizationProvider>
                        <span className="text-danger">
                          {errorList.time_boundary}
                        </span>
                      </div>
                    </div>

                    <div className="form-group row mt-3">
                      <label
                        for="staticEmail"
                        className="col-sm-2 col-form-label text-light "
                      >
                        Upload File
                      </label>

                      <div className="col-sm-3 mb-2">
                        <div className="row my-4">
                          <div className="col-md-5 text-white">
                            <img
                              src={file}
                              className="img-fluid avatar-img-src"
                              alt=""
                            />
                          </div>

                          <div className="col-md-7">
                            <input
                              type="file"
                              name="file"
                              id="file"
                              className="inputfile w-25"
                              onChange={(e) =>
                                handleImageChange(e.target.files)
                              }
                            />
                            <label for="file">
                              <i className="fas fa-cloud-upload-alt"></i> Upload
                              Banner
                            </label>
                            <span className="text-danger">
                              {errorList.banner}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-3 mb-2">
                        <div className="row my-4">
                          <div className="col-md-10">
                            <input
                              type="file"
                              name="file"
                              id="setFileV"
                              className="inputfile w-25"
                              onChange={(e) =>
                                handleVideoChange(e.target.files)
                              }
                            />
                            <label for="setFileV">
                              <i className="fas fa-cloud-upload-alt"></i> Upload
                              Video
                            </label>
                            <span className="text-danger">
                              {errorList.video}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-3 mb-2">
                        <div className="row my-4">
                          <div className="col-md-4 text-white">
                            <small>Number of video</small>
                          </div>
                          <div className="col-md-8 d-flex">
                            <div>
                              <Button
                                className="btnIncrementDecrement text-primary"
                                onClick={decrement}
                              >
                                <i className="fa fa-minus" aria-hidden="true"></i>
                              </Button>
                            </div>
                            <div>
                              {" "}
                              <Button className="btnIncrementDecrement text-primary">
                                {count}
                              </Button>{" "}
                            </div>
                            <div>
                              <Button
                                className="btnIncrementDecrement text-primary"
                                onClick={increment}
                              >
                                <i className="fas fa-plus"></i>
                              </Button>
                              <span className="text-danger">
                                {errorList.number_of_videos}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row justify-content-start mb-4">
                      <div className="col-md-3 text-left">
                        <button className="btn btn-warning mx-4">
                          Confirm
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>
    </>
  );
};

export default CreateEventRound;
